import React from 'react';

export const createInlineRenderers = () => ({
	'BOLD': (children, { key }) => <strong key={key}>{children}</strong>,
	'ITALIC': (children, { key }) => <em key={key} style={{ fontStyle: 'italic' }}>{children}</em>,
	'STRIKETHROUGH': (children, { key }) => <del key={key}>{children}</del>,
	'UNDERLINE': (children, { key }) => <u key={key}>{children}</u>,
	'CODE': (children, { key }) => <code key={key}>{children}</code>,
});



// WEBPACK FOOTER //
// ./lib/viewer/renderers/createInlineRenderers.js